import type { DiffConfig } from '@codemirror/merge';

export const COMPARER_DIFF_TIMEOUT_MS = 1000;

// Must not set `scanLimit`: @codemirror/merge then collapses the whole document
// into a single change once the differing region exceeds scanLimit * 64.
export const comparerDiffConfig: DiffConfig = {
  timeout: COMPARER_DIFF_TIMEOUT_MS,
};
